<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  import { setLanguage, translate } from 'src/i18n.js';  // Assuming the translate function is imported from your translation module
  
  export default {
    data() {
      return {
        currentLanguage: 'en',  // Default language can be set here
        translations: {
          // Placeholder for your translation object, can be replaced with actual translation data
          dashboard: {
            en: 'Dashboard',
            am: 'መድረክ',
          },
          // Add more translation keys here
        },
      };
    },
    methods: {
      onLanguageChanged(lang) {
        this.currentLanguage = lang;  // Update the language in the root data
        setLanguage(lang);  // Assume setLanguage will update the current language in your app
        this.$forceUpdate();  // Force Vue to re-render if necessary
      },
      translate(key) {
        // Translate using the current language
        return this.translations[key] ? this.translations[key][this.currentLanguage] : key;
      }
    },
    mounted() {
      // Initial language setup (could also come from a store or session)
      const savedLang = localStorage.getItem('lang') || 'en';  // Default to 'en' if nothing is saved
      this.onLanguageChanged(savedLang);
    }
  }
</script>

<style lang="scss">
  body {
    font-family: 'Roboto' !important;
  }
  .vue-notifyjs.notifications {
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;
    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }
    .list-enter {
      opacity: 0;
      transform: scale(1.1);
    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
    .btn {
      border-color: rgb(37, 91, 48) !important;
      color: rgb(37, 91, 48) !important;
    }
    .btn-outline-primary {
      border-color: rgb(37, 91, 48) !important;
      color: rgb(37, 91, 48) !important;
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active {
      color: #fff;
      background-color: rgb(37, 91, 48) !important;
      border-color: rgb(37, 91, 48) !important;
    }
    .badge-primary {
      color: rgba(240, 206, 13, 0.937) !important;
      background-color: rgb(37, 91, 48) !important;
    }
    .badge {
      padding: 0.5em 1.6em !important;
    }
  }
</style>
